import { useExperienceAddressState } from '../../../fields/ExperienceFields';
import { ExperienceCity } from './components/ExperienceCity';
import { ExperienceCounty } from './components/ExperienceCounty';
import { ExperienceState } from './components/ExperienceState';
import { ExperienceStreetAddress1 } from './components/ExperienceStreetAddress1';
import { ExperienceStreetAddress2 } from './components/ExperienceStreetAddress2';
import { ExperienceZipCode } from './components/ExperienceZipCode';
import { isMobileScreen } from '@apply/ui';

export interface ExperiencePropertyAddressProps {
    experienceId: string | undefined;
    required?: boolean;
    isReview?: boolean;
    readOnly?: boolean;
}

export const ExperiencePropertyAddress: React.FC<ExperiencePropertyAddressProps> = ({
    experienceId,
    required = false,
    readOnly = false,
}) => {
    const mobileScreen = isMobileScreen();
    const [state] = useExperienceAddressState(experienceId);
    return (
        <>
            <>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                    <ExperienceStreetAddress1
                        experienceId={experienceId}
                        required={required}
                        readOnly={readOnly}
                    />
                    <ExperienceStreetAddress2
                        experienceId={experienceId}
                        readOnly={readOnly}
                    />
                    <div
                        style={{
                            display: 'flex',
                            width: '100%',
                            gap: mobileScreen ? '0px' : '20px',
                            flexWrap: mobileScreen ? 'wrap' : 'nowrap',
                        }}
                    >
                        <ExperienceCity
                            experienceId={experienceId}
                            required={required}
                            readOnly={readOnly}
                        />
                        <ExperienceZipCode
                            experienceId={experienceId}
                            required={required}
                            readOnly={readOnly}
                        />
                        <ExperienceState
                            experienceId={experienceId}
                            required={required}
                            readOnly={readOnly}
                        />
                    </div>
                    <ExperienceCounty
                        experienceId={experienceId}
                        required={required}
                        readOnly={readOnly}
                        selectedState={state}
                    />
                </div>
            </>
        </>
    );
};
